// ============================================================
//  ALTIMO Medical Center — TooltipAyuda.jsx
//  Ícono de ayuda contextual (ⓘ) con texto explicativo al pasar el mouse.
//  Ubicación: src/components/TooltipAyuda.jsx
//
//  Uso:
//    import TooltipAyuda from './TooltipAyuda';
//    <label>Costo promedio <TooltipAyuda texto="Se recalcula..." /></label>
//
//  Sin estado, sin dependencias — solo CSS :hover. Inline, no rompe layout.
// ============================================================

import { useState } from 'react';

const COLOR_AZUL = '#1B2A5E';

export default function TooltipAyuda({ texto, posicion = 'arriba', ancho = 230 }) {
  const [visible, setVisible] = useState(false);

  const esArriba = posicion === 'arriba';

  return (
    <span
      style={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle', marginLeft: '5px' }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <span
        style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: '15px', height: '15px', borderRadius: '50%',
          background: '#e8f0fb', color: COLOR_AZUL,
          fontSize: '10px', fontWeight: '700', fontFamily: 'Georgia, serif',
          cursor: 'help', userSelect: 'none', flexShrink: 0,
          border: `1px solid ${COLOR_AZUL}33`,
        }}
      >
        i
      </span>

      {visible && (
        <span
          style={{
            position: 'absolute',
            ...(esArriba ? { bottom: '22px' } : { top: '22px' }),
            left: '50%', transform: 'translateX(-50%)',
            width: `${ancho}px`, maxWidth: '280px',
            background: COLOR_AZUL, color: '#fff',
            fontSize: '11.5px', fontWeight: '500', lineHeight: '1.45',
            padding: '9px 12px', borderRadius: '8px',
            boxShadow: '0 8px 24px rgba(0,0,0,.25)',
            zIndex: 5000, textAlign: 'left',
            fontFamily: 'Segoe UI, sans-serif',
            pointerEvents: 'none',
          }}
        >
          {texto}
          <span
            style={{
              position: 'absolute', left: '50%', transform: 'translateX(-50%)',
              ...(esArriba
                ? { bottom: '-4px', borderTop: `5px solid ${COLOR_AZUL}` }
                : { top: '-4px', borderBottom: `5px solid ${COLOR_AZUL}` }),
              width: 0, height: 0,
              borderLeft: '5px solid transparent', borderRight: '5px solid transparent',
            }}
          />
        </span>
      )}
    </span>
  );
}
